export default "__VITE_ASSET__vi07IfhP__";